// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/singles.scss";
import "./components/tableofcontent";
import "./components/readmore";

// Bloc calendar
import './plugins/bloc-calendar';

if ($(window).width() < 960) {
    import( './components/slider-gutenberg.js');
};